import { RowData, Table } from '../tanstackTypes';

export type ManageableItem = {
    id: string;
    label: string;
    leafIds: string[];
};

export function getManageableItems<TData extends RowData>(table: Table<TData>): ManageableItem[] {
    const topLevelColumns = table.getAllColumns().filter((c) => !c.parent);
    const items: ManageableItem[] = [];
    for (const col of topLevelColumns) {
        const leaves = col.getLeafColumns().filter((lc) => lc.getCanHide());
        if (leaves.length === 0) continue;
        if (col.columns.length > 0) {
            items.push({
                id: col.id,
                label: col.columnDef.meta?.label?.() ?? col.id,
                leafIds: leaves.map((l) => l.id),
            });
        } else if (col.getCanHide()) {
            items.push({
                id: col.id,
                label: col.columnDef.meta?.label?.() ?? col.id,
                leafIds: [col.id],
            });
        }
    }
    return items;
}

export function isItemVisible<TData extends RowData>(item: ManageableItem, table: Table<TData>): boolean {
    return item.leafIds.every((leafId) => {
        const col = table.getColumn(leafId);
        return col?.getIsVisible() ?? false;
    });
}
